module.exports = __webpack_public_path__ + "fb7a508ea8ecb5379ea5ae3d89b38af3.MP3";